import {
  PayloadRefferalType,
  ReferralPlayerResponseType,
  ReferralResponseType,
} from "types/referral";

export const referralApi = {
  async getReferral(_username: string) {
    return {
      status: 0,
      msg: "Success",
      data: {
        code: "TK88VIP",
        referral: {
          total: 5,
          detail: [
            {
              member_id: "user001",
              registered_date: "2026-09-01",
              total_comm: "150.00",
            },
            {
              member_id: "user002",
              registered_date: "2026-09-05",
              total_comm: "280.00",
            },
          ],
        },
        valid_referral: {
          total: 3,
          detail: [
            {
              member_id: "user001",
              registered_date: "2026-09-01",
              total_turnover: "5000.00",
            },
            {
              member_id: "user002",
              registered_date: "2026-09-05",
              total_turnover: "8000.00",
            },
          ],
        },
        reward: {
          total: "430.00",
          detail: [
            {
              date: "2026-09-10",
              distribution_time: "12:00:00",
              total_turnover: "13000.00",
              total_reward: "430.00",
            },
          ],
        },
      },
    } as unknown as ReferralResponseType;
  },
  async getReferralPlayerPromotion(_payload: PayloadRefferalType) {
    return {
      status: 0,
      msg: "Success",
      data: [
        {
          username: "tk88_member",
          player_referrer_username: "user001",
          reward_amount: "150.00",
          achieve_amount: "5000.00",
          current_amount: "5000.00",
          created_date: "2026-09-01",
          is_reward: "1",
          status: "Completed",
        },
      ],
      totalCount: 1,
    } as ReferralPlayerResponseType;
  },
};
